import {
  Button,
  Chip,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import classNames from 'classnames'
import { useKeywordsTranslation } from 'components/Common/ArticleSelector/useKeywordsTranslation'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { newProjectActions } from 'features/BillOfMaterials/store/newProjectReducer'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { KeywordDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectStateSelectors } from 'store/Project/ProjectSelectors'
import './MaterialKeywordFilter.scss'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    activeFilter: {
      backgroundColor: theme.palette.info.light,
      color: theme.palette.getContrastText(theme.palette.info.light),
      '&:focus': {
        backgroundColor: theme.palette.info.light,
        color: theme.palette.getContrastText(theme.palette.info.light),
      },
      '&:hover': {
        backgroundColor: theme.palette.info.dark,
        color: theme.palette.getContrastText(theme.palette.info.dark),
      },
    },
  })
)

export const MaterialKeywordFilter = () => {
  const { t } = useTranslation()
  const cn = useStyles()

  const { translateKeyword } = useKeywordsTranslation()

  // const [projectKeywords, setProjectKeywords] = useState(undefined)
  // const { availableFilters: availableKeywords, enabledFilters: selectedKeywords, disabledFilters: disabledKeywords } = useAppSelector((state: RootAppState) => state.newProjectReducer.filters.byMaterialKeywords.filter)
  const materialKeywordsFilter = useAppSelector(
    ProjectStateSelectors.MaterialFilterSelector,
    _.isEqual
  )

  const dispatch = useAppDispatch()

  const handleChange = (group: string, keyword: KeywordDto) => {
    const newEnabledTokens =
      { ...materialKeywordsFilter.filter.enabledFilters } || {}

    if (!_.isEmpty(newEnabledTokens[group])) {
      if (
        newEnabledTokens[group].findIndex(
          (x) => x.originalKeyword === keyword.originalKeyword
        ) > -1
      ) {
        newEnabledTokens[group] = newEnabledTokens[group].filter(
          (x) => x.originalKeyword !== keyword.originalKeyword
        )
        if (newEnabledTokens[group].length === 0) {
          delete newEnabledTokens[group]
        }
      } else {
        newEnabledTokens[group] = [...(newEnabledTokens[group] || []), keyword]
      }
    } else {
      newEnabledTokens[group] = [keyword]
    }

    // const newMaterialKeywordFilter = {
    //   [group]:
    //     materialKeywordsFilter.filter.enabledFilters &&
    //     materialKeywordsFilter.filter.enabledFilters[group]?.findIndex(
    //       (x) => x === keyword
    //     ) > -1
    //       ? materialKeywordsFilter.filter.enabledFilters[group]?.filter(
    //           (x) => x !== keyword
    //         )
    //       : [
    //           ...((materialKeywordsFilter.filter.enabledFilters &&
    //             materialKeywordsFilter.filter.enabledFilters[group]) ||
    //             []),
    //           keyword,
    //         ],
    // }

    dispatch(
      newProjectActions.setFilter({
        filter: {
          type: 'MaterialKeywordsFilter',
          enabledFilters: newEnabledTokens,
        },
      })
    )

    // if (!materialKeywordsFilter.active) {
    //   setTimeout(() =>
    //     dispatch(projectActions.ToggleFilter('MaterialKeywordsFilter'))
    //   )
    // }
  }

  const selectAllOrNothing = (howMany: 'all' | 'nothing') => {
    dispatch(
      newProjectActions.setFilter({
        filter: {
          type: 'MaterialKeywordsFilter',
          enabledFilters:
            howMany === 'all'
              ? materialKeywordsFilter.filter.availableFilters
              : {},
        },
      })
    )
  }

  return (
    <div className="filter-container">
      {/* <FormControlLabel
        control={
          <Switch
            checked={materialKeywordsFilter.active}
            onClick={() =>
              dispatch(projectActions.ToggleFilter('MaterialKeywordsFilter'))
            }
          />
        }
        labelPlacement={'start'}
        label={
          <LocalizedTypography translationKey="common:enable" variant="body2" />
        }
        className={'enable-filter-switch'}
      /> */}
      <div className="material-keywords-filter">
        {Object.keys(materialKeywordsFilter.filter.availableFilters || {}).map(
          (group) => {
            return (
              <div
                className="keyword-group"
                key={group}
                hidden={group === 'others'}
              >
                <Typography
                  variant="subtitle2"
                  color={
                    materialKeywordsFilter.active
                      ? 'textPrimary'
                      : 'textSecondary'
                  }
                >
                  {t(`project:material-category-${group}`, group)}
                </Typography>
                <div className="keywords">
                  {materialKeywordsFilter.filter.availableFilters[group].map(
                    (keyword) => {
                      return (
                        <Chip
                          key={keyword.originalKeyword}
                          className={classNames('keyword', {
                            [cn.activeFilter]:
                              materialKeywordsFilter.active &&
                              materialKeywordsFilter.filter?.enabledFilters &&
                              materialKeywordsFilter.filter.enabledFilters[
                                group
                              ]?.includes(keyword),
                          })}
                          size="small"
                          variant="default"
                          label={translateKeyword(keyword)}
                          // disabled={!materialKeywordsFilter.active}
                          onClick={() => handleChange(group, keyword)}
                        />
                      )
                    }
                  )}
                </div>
              </div>
            )
          }
        )}
      </div>
      <div className="filter-actions">
        {materialKeywordsFilter.active &&
        !Boolean(
          Object.keys(materialKeywordsFilter.filter?.enabledFilters || {})
            .length
        ) ? (
          <LocalizedTypography
            translationKey={'project:filter-empty-keywords-filter'}
            variant="caption"
            color="secondary"
          >
            filtering parts without any keywords
          </LocalizedTypography>
        ) : null}

        <Button
          variant="outlined"
          color="primary"
          // disabled={!materialKeywordsFilter.active}
          onClick={() => selectAllOrNothing('nothing')}
        >
          {t('common:none')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          // disabled={!materialKeywordsFilter.active}
          onClick={() => selectAllOrNothing('all')}
        >
          {t('common:all')}
        </Button>
      </div>
    </div>
  )
}
